import { defineStore } from "pinia";
import { jwtDecode } from "jwt-decode";
import router from "@/router";


export const userAccountStore = defineStore('userAccount', {
    id: 'useraccount',
    state: () => ({
        supperUserRemainder: {
            user: '',
            password: '',
            isSave: false
        },
        supperUserToken: '',
        supperUserProfile: {},

        userRemainder: {
            user: '',
            password: '',
            isSave: false
        },
        userToken: '',
        userProfile: {}

    }),
    actions: {
        supperUserProfileInfor() {
            return jwtDecode(this.supperUserToken);
        },
        supperUserLogout() {
            this.supperUserToken = '';
            this.supperUserProfile = {};

            router.push("/dashboard/login")
        },
        userLogout(path) {
            // this.userToken = "";
            this.userToken = '';
            this.userProfile = {};
            router.push(path ? path : "/user/login");
        },
        userLoginValidate() {
            if (this.userToken) {
                return true;
            } else {
                return false;
            }
        }


    },
    persist: {
        key: 'electosh-login-data',
        storage: localStorage
    }
})